import { Outlet } from "react-router-dom";


const Sos = () => {
  return (<Outlet />)
}
export default Sos;
